import { InboxOutlined } from '@ant-design/icons';
import { Col, Form, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min';
// import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomCard from '../../../components/Antd/Card';
import CustomButton from '../../../v2-components/Antd/Button';
import CustomDragDropUpload from '../../../v2-components/Antd/DragDropUpload';
import CustomFormItem from '../../../v2-components/Antd/FormItem';
import CustomImage from '../../../v2-components/Antd/Image';
import CustomInput from '../../../v2-components/Antd/Input';
import LoadingModal from '../../../v2-components/LoadingModal';
import { CustomNotification } from '../../../v2-components/Notification';
import { validateLocation } from '../../pharmacy-sliders/create/handle/location-class-validation.handle';
import { getName } from '../handle/get-name.handle';
import { Service } from '../service';
import { getBase64 } from './handle/get-base64.handle';
import { imageSpecsByModule } from './handle/image-specs-by-module.handle';
import { addPharmacyToTemplate } from '../handle/add-pharmacy-to-template.handle';
import './style.scss';
import usePharmacyIconStore from '../templates/store/pharmacy-store';
import { capitalizeFirstLetter } from './handle/capitalize-first-letter.handle';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';

export default function AdminPharmacyIconCreatePage() {
	const { template, location } = useParams();
	const [selectedPharmacy, locations, setLocations, platform, ecosystem] = usePharmacyIconStore((state) => [
		state.selectedPharmacy,
		state.locations,
		state.setLocations,
		state.platform,
		state.ecosystem,
	]);
	const [selectedLocation, setSelectedLocation] = useState({});
	const [hadServerImage, setHadServerImage] = useState(false);
	const [form] = Form.useForm();
	const [file, setFile] = useState(null);
	const [openLoadingModal, setOpenLoadingModal] = useState(false);
	const [isPreviewImg, setPreviewImg] = useState('');
	const [fileList, setFileList] = useState([]);

	// const { token } = GetLocalStorageValue('userInfo');

	useEffect(() => {
		if (locations && locations.length > 0) {
			const currentLocation = locations.find((item) => item.location === location);
			setSelectedLocation(currentLocation);

			const serverImg = currentLocation?.image;
			setHadServerImage(!!serverImg);

			if (serverImg) {
				setPreviewImg(serverImg);

				const uploadFile = {
					uid: '-1',
					name: 'current-image.png',
					status: 'done',
					url: serverImg,
				};
				setFile(uploadFile);
				setFileList([uploadFile]);
			} else {
				setPreviewImg('');
				setFile(null);
				setFileList([]);
			}
		}
	}, [form, location, locations]);

	const handlePreview = async (item) => {
		if (item.url) {
			setPreviewImg(item.url);
		} else if (!item.url && !item.preview) {
			item.preview = await getBase64(item.originFileObj);
			setPreviewImg(item.preview);
		} else {
			setPreviewImg('');
		}
	};

	const handleUpload = (info) => {
		const list = info.fileList.slice(-1);
		setFileList(list);

		const last = list[0];
		if (last) {
			setFile(last);
			handlePreview(last);
		} else {
			setFile(null);
			setPreviewImg('');
		}
	};

	const handleOnFinish = async () => {
		setOpenLoadingModal(true);

		try {
			if (file?.originFileObj) {
				const formData = new FormData();
				formData.append('file', file.originFileObj);
				formData.append('template', template);
				formData.append('location', location);
				formData.append('platform', ecosystem);
				formData.append('pharmacy', selectedPharmacy);
				formData.append('country', Enviroment.COUNTRY);

				const response = await new Service().createFile(formData);
				setLocations(response.modules);
				setHadServerImage(true);
				CustomNotification({ type: 'success', description: 'Imagen guardada exitosamente' });
				return;
			}

			if (!file && hadServerImage) {
				const payload = {
					country: Enviroment.COUNTRY,
					pharmacy: selectedPharmacy,
					template,
					platform: ecosystem,
					location,
				};

				const response = await new Service().deleteFile(payload);
				setLocations(response.modules);
				setPreviewImg('');
				setFile(null);
				setFileList([]);
				setHadServerImage(false);
				CustomNotification({ type: 'success', description: 'Imagen eliminada exitosamente' });
				return;
			}

			CustomNotification({ type: 'info', description: 'No hay cambios por guardar.' });
		} catch (error) {
			CustomNotification({
				type: 'error',
				description: 'Ocurrió un error procesando la operación',
				message: error?.response?.data || error?.message,
			});
		} finally {
			setOpenLoadingModal(false);
		}
	};

	const handleDeleteImg = () => {
		setPreviewImg('');
		setFile(null);
		setFileList([]);
	};


	return (
		<div className="admin-pharmacy-sliders-create">
			<h1>{'Crear imagen'}</h1>
			<Link to={`/v2/admin-pharmacy-icons/templates/${template}`}>
				Volver a {capitalizeFirstLetter(platform) + ' '}
				{getName(platform, selectedPharmacy)} / {template}{' '}
				{addPharmacyToTemplate(platform, selectedPharmacy)}
			</Link>
			<Row className="create-file-cards-container" gutter={[16, 16]}>
				<Col md={12} xs={24}>
					<CustomCard title={'Datos del Módulo'}>
						<Form
							form={form}
							initialValues={{
								pharmacy: capitalizeFirstLetter(platform) + ' ' + getName(platform, selectedPharmacy),
								template: template,
								location: location,
								file: file,
							}}
							onFinish={handleOnFinish}
							className="create-form"
						>
							<div className="selects-container">
								<CustomFormItem name={'pharmacy'} label={'Plataforma'}>
									<CustomInput disabled={true} />
								</CustomFormItem>
								<CustomFormItem name={'template'} label={'Página'}>
									<CustomInput disabled={true} />
								</CustomFormItem>
							</div>

							<CustomFormItem name={'location'} label={'Módulo'}>
								<CustomInput disabled={true} />
							</CustomFormItem>
							<br />

							<CustomFormItem name="file" label={'Cargar imagen'} className="ant-form-vertical form-sub-titles">
								<div>
									<p className="file-format"> {imageSpecsByModule(location)}</p>
									<CustomDragDropUpload
										accept=".jpg, .png, .ico"
										maxCount={1}
										beforeUpload={() => false}
										multiple={false}
										onChange={(info) => handleUpload(info)}
										onRemove={() => handleDeleteImg()}
										className="upload-image-container"
										showUploadList={false}
										fileList={fileList}
									>
										{!isPreviewImg ? (
											<div className="drag-drop-frame">
												<InboxOutlined className="drag-drop-icon" />
												<p className="ant-upload-text">Haga clic o arrastre el archivo a esta área para cargarlo.</p>
											</div>
										) : (
											<div className="uploaded-img-container">
												<CustomImage alt="example" src={isPreviewImg} style={{ width: '100%' }} preview={false} />
											</div>
										)}
									</CustomDragDropUpload>

									<div className={'delete-span-container'}>
										<span className={`${!isPreviewImg && 'disabled-span'}`} onClick={handleDeleteImg}>
											Eliminar
										</span>
									</div>
								</div>
							</CustomFormItem>
							<div className="save-button-container">
								<CustomButton type="default" htmlType="submit">
									Guardar
								</CustomButton>
							</div>
						</Form>
					</CustomCard>
				</Col>
				<Col md={12} xs={24}>
					<CustomCard className={'create-img-container'}>
						<CustomImage className={validateLocation(location, 'width100')} src={selectedLocation?.img_cover} alt="img" />
					</CustomCard>
				</Col>
			</Row>
			<LoadingModal visible={openLoadingModal} />
		</div>
	);
}
